<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-12">
          <div class="button-items mt-1" style="float: left;padding-left: 1%;">
            <h2>Users</h2>
          </div>
          <div class="button-items" style="float: right;" >
            <button class="btn btn-primary btn-sm" (click)="loadUserData(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i
            class="mdi mdi-reload"></i></button>
            <button class="btn btn-primary btn-sm" (click)="dt.clear()" pTooltip="Clear all column filters and sorting" appActionTooltip>Clear<i
            class="mdi mdi-filter-remove"></i></button>
          </div>
          <!-- <div class="button-items mt-3 mb-3" style="float: right;">
          <button class="btn btn-primary btn-sm"  (click)="addUser()" >Add User</button>
        </div> -->
      </div>
    </div>
    <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadUserData($event)" [value]="users" dataKey="id" styleClass="p-datatable-users" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
      responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0" paginatorDropdownAppendTo="body">
      <ng-template pTemplate="header" let-columns >
        <tr>
          <th style="width:7em;padding:1rem !important;">
            View/Edit
          </th>
          <th pSortableColumn="firstName">
            <div class="flex align-items-center">
              First Name
              <p-sortIcon field="firstName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="firstName"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="lastName">
            <div class="flex align-items-center">
              Last Name
              <p-sortIcon field="lastName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="lastName"
              display="menu"></p-columnFilter>
            </div>
          </th>

          <th pSortableColumn="mainEmail">
            <div class="flex align-items-center">
              Email
              <p-sortIcon field="mainEmail"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="mainEmail"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="isActive">
            <div class="flex align-items-center">
              Active
              <p-sortIcon field="isActive"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="finCenId">
            <div class="flex align-items-center">
              FincenId
              <p-sortIcon field="finCenId"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="finCenId"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="phoneNumber">
            <div class="flex align-items-center">
              Phone
              <p-sortIcon field="phoneNumber"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="phoneNumber"
              display="menu"></p-columnFilter>
            </div>
          </th>

          <th pSortableColumn="timeZone">
            <div class="flex align-items-center">
              Time Zone
              <p-sortIcon field="timeZone"></p-sortIcon>
              <p-columnFilter matchMode="equals" [showOperator]="false" [showAddButton]="false"
                type="text" field="timeZone"
                display="menu">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown [ngModel]="value" [options]="timeZones"
                    (onChange)="filter($event.value)" placeholder="Any">
                    <ng-template let-option pTemplate="item">
                      <span
                      [class]="'customer-badge status-' + option">{{option}}</span>
                    </ng-template>
                  </p-dropdown>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="roleCodes">
            <div class="flex align-items-center">
              Role
              <p-sortIcon field="roleCodes"></p-sortIcon>
              <p-columnFilter field="roleCodes"  matchMode="in" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false" [showClearButton]="false" [showApplyButton]="false" display="menu">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [maxSelectedLabels]="10000" [ngModel]="value" [options]="roles" optionLabel="key" optionValue="value" placeholder="Any" (onChange)="filter($event.value)">
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-representative-option">
                        <span [class]="'customer-badge status-' + option.key">{{option.key}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="type">
            <div class="flex align-items-center">
              Type
              <p-sortIcon field="type"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="type" display="menu"
              ></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="tkPracticeArea">
            <div class="flex align-items-center">
              TK Practice Area(s)
              <p-sortIcon field="tkPracticeArea"></p-sortIcon>
              <p-columnFilter field="tkPracticeArea"  matchMode="in" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false" [showClearButton]="false" [showApplyButton]="false" display="menu">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [maxSelectedLabels]="10000" [ngModel]="value" [options]="tkPracticeAreas" optionLabel="description" optionValue="description" placeholder="Any" (onChange)="filter($event.value)">
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-representative-option">
                        <span [class]="'customer-badge status-' + option.description">{{option.description}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="pmPracticeArea">
            <div class="flex align-items-center">
              PM Practice Area(s)
              <p-sortIcon field="pmPracticeArea"></p-sortIcon>
              <p-columnFilter field="pmPracticeArea" matchMode="in" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false" [showClearButton]="false" [showApplyButton]="false" display="menu">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [maxSelectedLabels]="10000" [ngModel]="value" [options]="tkPracticeAreas" optionLabel="description" optionValue="description" placeholder="Any" (onChange)="filter($event.value)">
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-representative-option">
                        <span [class]="'customer-badge status-' + option.description">{{option.description}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <!-- <th pSortableColumn="approver">
          <div class="flex align-items-center">
            Approver
            <p-sortIcon field="approver"></p-sortIcon>
            <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
              type="text" field="approver"
            display="menu"></p-columnFilter>
          </div>
        </th> -->
        <th pSortableColumn="tkAutoApproval">
          <div class="flex align-items-center">
            Is Auto Approver
            <p-sortIcon field="tkAutoApproval"></p-sortIcon>
            <p-columnFilter [showClearButton]="true" [showApplyButton]="true" [showOperator]="false" [showAddButton]="false" [showMatchModes]="false"
              field="tkAutoApproval" display="menu">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" [options]="booleanFilterOptions"
                  (onChange)="filter($event.value)" placeholder="Any">
                  <ng-template let-option pTemplate="item">
                    <span
                    [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                  </ng-template>
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>

      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-users let-columns="columns">
  <tr>
    <!-- Action Buttons Column -->
    <td style="width: 1%; white-space: nowrap;">
      <div class="d-flex align-items-center gap-2">
        <!-- View Button -->
        <a class="btn btn-info btn-sm" pTooltip="View user details" appActionTooltip (click)="viewUsers(users)" role="button">
          <i class="mdi mdi-eye"></i>
        </a>

        <!-- Edit Button -->
        <span appActionTooltip [pTooltip]="users.isActive != 'Yes' ? 'Only active users can be edited' : 'Edit user'" [actionDisabled]="users.isActive != 'Yes'">
          <button class="btn btn-warning btn-sm" [disabled]="users.isActive != 'Yes'" (click)="editUsers(users)">
            <i class="mdi mdi-pencil"></i>
          </button>
        </span>

        <!-- Activate / Deactivate Button -->
        <button class="btn btn-danger btn-sm" pTooltip="Activate or deactivate this user" appActionTooltip (click)="confirmUserAction('inactivate', users)">
          <i class="mdi mdi-block-helper"></i>
        </button>
        
        <!-- Reset Button -->
        <button class="btn btn-warning btn-sm" pTooltip="Reset MFA" appActionTooltip (click)="confirmUserAction('reset', users)">
          <i class="mdi mdi-lock-reset"></i>
        </button>
      </div>
    </td>

    <!-- Data Columns -->
    @for (col of columns; track col) {
      <td>
        <div class="al-cell-clamp" [title]="users[col.field]">{{ users[col.field] }}</div>
      </td>
    }
  </tr>
</ng-template>
<ng-template pTemplate="emptymessage">
  <tr>
    <td [attr.colspan]="4">
      No records found
    </td>
  </tr>
</ng-template>
</p-table>
</div>
</div>
</div>
<p-dialog (onHide)="closeDialog()" [(visible)]="userDialog" [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid" [resizable]="false" [draggable]="false">
  <ng-template pTemplate="content">
    <app-user-modal (closeDialogonChange)="closeDialog($event)" [(roles)]="roles" [(user)]="user" [(newUser)]="newUser" [viewOnly]="viewOnly" ></app-user-modal>
  </ng-template>

</p-dialog>
<app-confirmation-alert [showAlert]="!!pendingUserAction" [message]="userActionConfirmMessage"
  (response)="onUserActionConfirm($event)"></app-confirmation-alert>